import { useMemo } from 'react'
import { useTranslation } from 'next-i18next'

import { WidgetProps } from '@/features/resources/components/WidgetList/Widget'

export const usePlatformData = (): WidgetProps[] => {
  const {
    t,
    i18n: { language },
  } = useTranslation('training')

  return useMemo(
    () => [
      {
        title: t('contents.platform.list.0'),
        image: '/images/resources/form/presentation.svg',
        sx: {
          '.chakra-aspect-ratio': { margin: '0 auto' },
          p: { textAlign: 'center' },
        },
      },
      {
        title: t('contents.platform.list.1'),
        image: '/images/resources/form/videoconference.svg',
        sx: {
          '.chakra-aspect-ratio': { margin: '0 auto' },
          p: { textAlign: 'center' },
        },
      },
    ],
    [language],
  )
}

export const useDetailOfTrainer = (): {
  title: string
  leftList?: string[]
  rightList?: string[]
  subtitle?: string
}[] => {
  const {
    t,
    i18n: { language },
  } = useTranslation('training')
  return useMemo(() => {
    return [
      {
        title: t('contents.detail.list.0.title'),
        leftList: [
          t('contents.detail.list.0.list.0'),
          t('contents.detail.list.0.list.1'),
          t('contents.detail.list.0.list.2'),
          t('contents.detail.list.0.list.3'),
          t('contents.detail.list.0.list.4'),
        ],
        rightList: [
          t('contents.detail.list.0.list.5'),
          t('contents.detail.list.0.list.6'),
          t('contents.detail.list.0.list.7'),
          t('contents.detail.list.0.list.8'),
          t('contents.detail.list.0.list.9'),
          t('contents.detail.list.0.list.10'),
        ],
      },
      {
        title: t('contents.detail.list.1.title'),
        subtitle: t('contents.detail.list.1.subtitle'),
      },
      {
        title: t('contents.detail.list.2.title'),
      },
      {
        title: t('contents.detail.list.3.title'),
      },
    ]
  }, [language])
}
